<template>
    <div>
        <!--出倉-->
        <div  class="ind_main ind_main2">
            <el-form ref="form" :model="form" label-width="120px" >
                <div class="ind_cont rk_cont">
                    <div class="ruku_top">
                        <div class="ruku_from">
                            <el-col :span="12">
                                <el-form-item  label="工作單號 :" >
                                    <template v-if="form.sCodeShow"> <span style="color: black;font-size: 16px;">{{form.sCode}}</span></template>
                                    <template v-else>
                                        <!--<el-input size="medium" v-model="form.sCode" :disabled="form.sCodeShow" style="width: 65%" ></el-input>-->
                                        <el-select style="width: 65%" size="medium" :disabled="form.sCodeShow"
                                                   v-model="form.sCode" filterable remote
                                                   reserve-keyword @change="handleSelect($event)" @focus="isNullOptions()"
                                                   placeholder="" :remote-method="remoteMethodIn" :loading="tableloading">
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客戶編號 :" >
                                    <span style="color: black;font-size: 16px;">{{form.code}}</span>
                                    <!--<template v-if="form.codeShow"><span style="color: black;font-size: 16px;">{{form.code}}</span></template>-->
                                    <!--<template v-else="">-->
                                    <!--<el-select style="width: 65%" size="medium" :disabled="form.codeShow"-->
                                    <!--v-model="form.code" filterable remote-->
                                    <!--reserve-keyword @change="handleSelect($event)"-->
                                    <!--placeholder="" :remote-method="remoteMethod" :loading="tableloading">-->
                                    <!--<el-option-->
                                    <!--v-for="item in options4"-->
                                    <!--:key="item.value"-->
                                    <!--:label="item.label"-->
                                    <!--:value="item.value">-->
                                    <!--</el-option>-->
                                    <!--</el-select>-->
                                    <!--</template>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item  label="姓  名 :" >
                                    <span style="color: black;font-size: 16px;">{{form.name}}</span>
                                    <!--<template v-if="form.nameShow"><span style="color: black;font-size: 16px;">{{form.name}}</span></template>-->
                                    <!--<template v-else="">-->
                                    <!--<el-input v-model="form.name" style="width: 65%" size="medium" :disabled="form.nameShow"></el-input>-->
                                    <!--</template>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item  label="電  話 :" >
                                    <span style="color: black;font-size: 16px;">{{form.phone}}</span>
                                    <!--<template v-if="form.phoneShow"><span style="color: black;font-size: 16px;">{{form.phone}}</span></template>-->
                                    <!--<template v-else="">-->
                                    <!--<el-input v-model="form.phone" style="width: 65%" size="medium" :disabled="form.phoneShow"></el-input>-->
                                    <!--</template>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item  label="銷售員 :" >
                                    <span style="color: black;font-size: 16px;">{{form.sales}}</span>
                                    <!--<template v-if="form.salesShow"><span style="color: black;font-size: 16px;">{{form.sales}}</span></template>-->
                                    <!--<template v-else="">-->
                                    <!--<el-input v-model="form.sales" style="width: 65%" size="medium" :disabled="form.salesShow"></el-input>-->
                                    <!--</template>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item  label="地  址 :" >
                                    <span style="color: black;font-size: 16px;word-wrap: break-word;word-break: normal;">{{form.address}}</span>
                                    <!--<template v-if="form.addressShow"><span style="color: black;font-size: 16px;word-wrap: break-word;word-break: normal;">{{form.address}}</span></template>-->
                                    <!--<template v-else="">-->
                                    <!--<el-input v-model="form.address" style="width: 65%" size="medium" :disabled="form.addressShow"></el-input>-->
                                    <!--</template>-->
                                </el-form-item>
                            </el-col>
                            <!--<el-col :span="12">-->
                            <!--<el-form-item  label="時  間 :" >-->
                            <!--<span style="color: black;font-size: 16px;">{{form.createDate}}</span>-->
                            <!--</el-form-item>-->
                            <!--</el-col>-->
                            <template v-if="canAdd">
                                <template v-if="!rkCont">
                                    <el-col :span="12" style="text-align: right">
                                        <el-button type="primary" @click="handleSelect()">新 建</el-button>
                                    </el-col>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="ruku_list">
                    <template v-for="(stor,index) in addStorOnList">
                        <table v-if="addStorOn" cellspacing="0" cellpadding="0" class="responsive" :key="index">
                            <thead>
                            <tr><th colspan="5">可出倉</th></tr>
                            <tr>
                                <th width="12%">單位</th>
                                <th width="10%">編號</th>
                                <th width="40%">物品</th>
                                <!-- <th width="10%">數量</th> -->
                                <th>位置</th>
                                <th>出倉</th>
                            </tr>
                            </thead>
                            <tr v-for="(storOn,index) in stor.storOnItem" :id="storOn.id" :class="storOn.state === 1?'stateShow':''" :key="index">
                                <td class="actions">{{storOn.unit}}</td>
                                <td class="number">{{storOn.boxNo}}</td>
                                <td class="name" style="text-align: left;">{{storOn.item}}</td>
                                <!-- <td class="actions">{{storOn.qty}}</td> -->
                                <td class="actions">{{storOn.value}}</td>
                                <td class="actions">
                                    <label class="my_protocol">
                                        <input type="checkbox" @click='checkedOne(index)' /><span></span>
                                    </label>
                                </td>
                            </tr>
                            <tr><td colspan="5"><br/></td></tr>
                        </table>
                    </template>
                    <template v-for="(stor,index) in storOnList">
                        <table cellspacing="0" cellpadding="0" class="responsive" :key="index">
                            <thead>
                            <template v-if="!rkCont">
                                <tr>
                                    <th colspan="4">
                                        <span style="float: left;">{{stor.createDate}}</span>
                                        <span style="padding-right: 215px;">已出倉</span>
                                    </th>
                                    <th colspan="1">
                                        <el-button @click='printing(stor.storOnItem[0])'>打印</el-button>
                                        <template v-if="stor.state === 1">
                                            <el-button @click='storOn(stor)'>確定出倉</el-button>
                                        </template>
                                    </th>
                                </tr>
                            </template>
                            <tr>
                                <th width="12%">單位</th>
                                <th width="10%">編號</th>
                                <th width="25%">物品</th>
                                <!-- <th width="10%">數量</th> -->
                                <th>位置</th>
                                <th width="10%">
                                    體積<span v-if="storOnList[0].storOnItem[0].unitVolume">({{storOnList[0].storOnItem[0].unitVolume==='1'?'箱':storOnList[0].storOnItem[0].unitVolume==='2'?'cu.ft':'m³'}})</span>
                                </th>
                                <th width="10%">件數</th>
                                <template v-if="rkCont">
                                    <th>操作</th>
                                </template>
                                <template v-if="rkCont">
                                    <th width="18%">備注</th>
                                </template>
                            </tr>
                            </thead>
                            <tr v-for="(storOn,index) in stor.storOnItem" :key="index">
                                <td class="actions">{{storOn.unit}}</td>
                                <td class="number">{{storOn.boxNo}}</td>
                                <td class="name" style="text-align: left;">{{storOn.item}}</td>
                                <!-- <td class="actions">{{storOn.qty}}</td> -->
                                <td class="actions">{{storOn.value}}</td>
                                <td class="actions">{{storOn.remainingVolume}}</td>
                                <td class="actions">{{storOn.remainingQuantity}}</td>
                                <template v-if="rkCont">
                                    <td class="actions">
                                        <el-button size="small" type="primary" @click="handleStor(index)">
                                            出倉
                                        </el-button>
                                        <!-- <el-checkbox v-model="storOn.checked" @change="changeOne($event,storOn, index)"></el-checkbox> -->
                                        <!-- <label class="my_protocol">
                                            <input type="checkbox" @click="checkedOne(index, storOn)"/><span></span>
                                        </label> -->
                                    </td>
                                </template>
                                <template v-if="rkCont">
                                    <td class="actions" width="18%">{{storOn.remark}}</td>
                                </template>
                            </tr>
                            <tr><td colspan="7"></td></tr>
                        </table>
                    </template>
                    <div class="rk_btn">
                        <template v-if="canEdit">
                        <el-button type="primary"  @click="submitStorIn" icon="el-icon-check" circle> 保 存</el-button>
                        </template>
                        <el-button v-if="$store.getters.customerOnSte == false" type="warning"  @click="retSearch" icon="el-icon-delete" circle> 取 消</el-button>
                        <el-button v-if="$store.getters.customerOnSte"  type="warning"  @click ="retSearch" icon="el-icon-delete" circle> 返回</el-button>
                    </div>

                </div>
            </el-form>
        </div>
        <!-- 編輯页面-->
        <el-dialog title="出倉" :visible.sync="dialogVisible" width="500px" :close-on-click-modal=false :show-close=false>
            <el-form :model="dialogForm" label-width="120px">
                <el-form-item label="編號">
                    <span>{{dialogForm.boxNo}}</span>
                </el-form-item>
                <el-form-item label="物品">
                    <span>{{dialogForm.item}}</span>
                </el-form-item>
                <el-form-item :label="'出整' + dialogForm.unit">
                    <el-checkbox v-model="dialogForm.state" :true-label="1" :false-label="0" @change="handleAll"></el-checkbox>
                </el-form-item>
                <el-form-item label="出部分">
                    <el-checkbox v-model="dialogForm.state" :true-label="4" :false-label="0" style="margin-right: 10px" @change="handleAll"></el-checkbox>
                    <el-input-number size="small" v-model="dialogForm.quantity" :min="1" :max="dialogForm.remainingQuantity" label="" />
                </el-form-item>
                <el-form-item label="">
                    <template slot="label">
                        出倉體積
                    </template>
                    <el-input size="small" v-model="dialogForm.volume" @blur="handleBlurVolume" @input="$forceUpdate()" :disabled="!this.dialogForm.remainingVolume || volumeDisabled" style="width: 160px"/><span v-if="dialogForm.unitVolume"> {{dialogForm.unitVolume==='1'?'箱':dialogForm.unitVolume==='2'?'cu.ft':'m³'}}</span>
                </el-form-item>
                <el-form-item label="出倉金額">
                    {{ formatCurrency(dialogForm.amount) }}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="handleItem">確定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getStorOnList,getCustomerById,getCustomerCodeList,selStorInItemCustomerId,insertStorOn,getStorOnItemStorinIdBy,
        getStorInCodeList,getStorInListId,getStorOnListId,getStorOnCodeList,getStorOnOkList,getStaffAllList } from '../api/api'
    import axios from 'axios'
    export default {
        components: {
        },
        data() {
            return{
                volumeDisabled: false,
                dialogVisible: false,
                dialogForm: {},
                curIndex: null,
                options4: [],
                options:[],
                list: [],
                tableloading:false,
                show:true,
                add:false,
                addStorOn:false,
                cId:0,
                storDateId:0,//當前已出倉的日期表id
                storOnCustomerList:[],
                customerCode:{},
                storOnList:[],
                addStorOnList:[],
                codeList:[],
                codeInList:[],//入庫單號
                addstorOnList:[],
                rkCont:true,//入庫和客戶資訊
                addStorOnMap:new Map(),
                createDate:"",//時間
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                form:{
                    id:null,
                    sCode:null,
                    code:null,
                    name:null,
                    phone:null,
                    address:null,
                    sales:null,
                    createDate:null,
                    sCodeShow:false,
                    codeShow:false,
                    nameShow:false,
                    phoneShow:false,
                    addressShow:false,
                    salesShow:false,
                },
                searchStorOn:'',
                searchName:'',
                searchSalesId:'',
                custSalesList:[]
            }
        },
        mounted(){

        },
        methods: {
            handleAll(val){
                if(val==1) {
                    this.dialogForm.volume = this.dialogForm.remainingVolume
                    this.volumeDisabled = true
                    const sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100)
                    this.dialogForm.amount = sum / 100
                }
                if(val==0) {
                    this.dialogForm.volume = null
                    this.volumeDisabled = false
                    this.dialogForm.amount = null
                }
                if(val==4) {
                    this.volumeDisabled = false
                }
                this.$forceUpdate()
            },
            formatCurrency(amount, decimalPlaces = 2) {
                if(!amount) return
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: decimalPlaces
                });
                return `${formatter.format(amount)}`;
            },
            handleBlurVolume() {
                const value = Number(this.dialogForm.volume)
                let regex = /^(0|[1-9][0-9]*)$/
                let message = '請輸入大於0等于0的整數'
                if(this.dialogForm.unitVolume=='3'){
                    regex = /^(([1-9][0-9]{0,2}(,\\d{3})*)|0)(\.\d{1,2})?$/
                    message='请输入大于等于零最多两位小数的数字'
                }else{
                    regex = /^(0|[1-9][0-9]*)$/
                    message = '請輸入大於0等于0的整數'
                }
                if(!regex.test(value)){
                    if(value == '' || value == null){

                    }else this.$message({ type: 'warning', message: '請輸入大於0等于0的整數' })
                    this.dialogForm.volume = null
                    this.dialogForm.amount = 0
                    this.$forceUpdate()
                    return
                }
                if(value > Number(this.dialogForm.remainingVolume)) {
                    this.$message({ type: 'warning', message: '出倉體積不能大於剩餘體積' })
                    this.dialogForm.volume = null
                    this.dialogForm.amount = 0
                    this.$forceUpdate()
                    return
                }
                
                const sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100)
                this.dialogForm.amount = sum / 100
                this.$forceUpdate()
            },
            printing(item){/*打印*/
                if(item !== null){
                    let url=axios.defaults.baseURL+"/getPrintingList?custId="+item.cid+"&storOnDateId="+item.storDateId + "&token="+ this.$store.getters.staff.token;
                    window.location.href=url;
                }
            },
            storOn(stor){/*確定真的出倉了*/
                let params={storOnItemList:stor.storOnItem};
                this.$confirm('確定是否出倉? ', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    getStorOnOkList(params).then(data =>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            this.$message({
                                message: '出倉成功',
                                type: 'success'
                            });
                            this.cancelAdd();
                            this.getStorOnList();
                        }
                    })
                });
            },
            retSearch(){	//返回搜索界面
                this.$router.push({
                    name: '出倉',
                    params: {str: new Date().getTime()}
                })
                this.$store.commit("closeTab", 'addStockout');
            },
            getCodeList(){
                getStorOnCodeList().then(data =>{/*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.codeList = res.data;
                    }
                });
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options4 = this.list.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options4 = [];
                }
            },
            remoteMethodIn(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.codeInList.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            handleCurrentChange(){/*分頁*/
                this.getStorOnList();
            },
            selSotrOn(id){/*查詢出倉詳情*/
                this.$store.commit("setSearchSte",false);
                this.$store.commit("setCustomerOnSte",false);
                this.add = true;
                this.show = false;
                this.rkCont=false;
                getStorOnItemStorinIdBy(id).then(data =>{
                    let {data:res={}}=data;
                    //console.log("res",res);
                    if(res.errcode===200){
                        let sotrOnMap= new Map();
                        let storDateId=null;
                        res.data.forEach((item,i)=> {//重新處理下資料
                            if(i===0){
                                this.createDate = new Date(item.createDate*1000).Format("yyyy年MM月dd日 hh:mm");
                            }
                            this.storDateId=item.storDateId;
                            let itemList={};
                            let floor;this.cId=item.cId;
                            floor=item.name;
                            if(new Date(new Date( item.createDate *1000)).toDateString() !== new Date().toDateString()){//是否是當天時間 不是當天的時間不能修改
                                itemList= {storInItemId:item.storInItemId,cid:item.cId,satae:0,unit:item.unit,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,
                                    locationId:item.locationId,value:floor,storDateId:item.storDateId,volume:item.volume,amount:item.amount,remainingQuantity:item.remainingQuantity,remainingVolume:item.remainingVolume,unitVolume:item.unitVolume,unitPrice:item.unitPrice,quantity:item.quantity,checked:false};
                            }else{
                                itemList= {storInItemId:item.storInItemId,cid:item.cId,satae:0,unit:item.unit,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,
                                    locationId:item.locationId,value:floor,storDateId:item.storDateId,volume:item.volume,amount:item.amount,remainingQuantity:item.remainingQuantity,remainingVolume:item.remainingVolume,unitVolume:item.unitVolume,unitPrice:item.unitPrice,quantity:item.quantity,checked:false};
                            }
                            if(!sotrOnMap.has(item.storDateId)){//添加
                                let storIdItemList={id:item.id,state:item.state,createDate:new Date(item.createDate*1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem:[itemList]};
                                sotrOnMap.set(item.storDateId,storIdItemList);
                            }else{
                                sotrOnMap.get(item.storDateId).storOnItem.push(itemList)
                            }
                            // sotrOnMap.set(item.id,itemList)
                        });
                        this.storOnList =[... sotrOnMap.values()];
                        //console.log( this.storOnList);
                        this.selCustimerId(this.storDateId);//查詢客戶id
                        this.form.codeShow = true;
                        this.form.sCodeShow = true;
                        this.form.nameShow = true;
                        this.form.phoneShow = true;
                        this.form.addressShow = true;
                        this.form.salesShow = true;
                    }
                });

//				getPrintingListByStorDateId(32).then( data =>{
//                    let {data:res={}}=data;
//                    console.log("res",res);
//				});
//
//                getPrintingList({custId:30,storOnDateId:32}).then( data =>{
//                    let {data:res={}}=data;
//                    console.log("res",res);
//                })
            },
            selCustimerId(id){/*查詢客戶ID*/
                //console.log("id",id)
                getStorOnListId(id).then(data =>{
                    let {data:res={}}=data;
                    //console.log(res);
                    if(res.errcode===200){
                        let {id,code,name,phone,address,sales,createDate}=res.data.customer;
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =sales;
                        this.form.createDate =new Date(createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        this.form.sCode =res.data.scode;
                    }
                })
            },
            getStorOnList(){/*查詢入庫*/
                this.getCodeList();
                this.tableloading = true;
                this.rkCont=true;
                let params = {page: this.pager.page, size: this.pager.size,storOn:this.searchStorOn,custName:this.searchName,salesId:this.searchSalesId};
                return getStorOnList(params).then(data => {
                    let {data: res = {}} = data;
                    //console.log("res",res)
                    if (res.errcode === 200) {
                        let {size, page, total, data: items = []} = res.data;
                        this.storOnCustomerList=items;
                        this.storOnCustomerList.forEach((a,b)=>{
                            a.storInDate = new Date(a.onDate*1000).Format("yyyy-MM-dd hh:mm");
                            this.$set(this.storOnCustomerList[b],'value',a.customer.code);//向陣列裡添加value欄位
                        });
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            },
            storInAdd(){/*顯示添加入庫資訊 關閉入庫資訊*/
                this.add = true;
                this.show = false;
                this.rkCont = true;
                this.nullList();
                this.getInCodeList();
            },
            cancelAdd(){
                this.add = false;
                this.show = true;
                this.addStorOn = false;
                this.nullList();
            },
            handleSelect(cid){/*選擇出倉后*/
                var str=[];
                if(cid === null || cid === undefined){
                    this.addStorOn = true;
                    cid = this.cId;
                }else{
                    str = cid.split(',');
                    cid = str[0];
                }
                getCustomerById(cid).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {id,code,name,phone,address,sales}=res.data[0];
                        this.form.id = id;
                        this.form.code =code;
                        this.form.name =name;
                        this.form.address =address;
                        this.form.phone =phone;
                        this.form.sales =sales;
                        var codeId = this.form.sCode.split(',');
                        if(codeId[1] !== undefined){//確定codeID中是否有值
                            code = codeId[1];
                        }else{ code = this.form.sCode; }
                        let params = {page: this.pager.page, size: this.pager.size,id:id,code:code};
                        //console.log("2",params);
                        selStorInItemCustomerId(params).then(data =>{
                            let {data:res={}}=data;
                            if(res.errcode===200){
                                let sotrOnMap= new Map();
                                res.data.data.forEach((item,i)=>{//重新處理下資料
                                    let floor;
                                    if(item.floor === 0){ floor= "GF "+item.name; }else { floor=item.floor+"F "+item.name; }
                                    let itemList = {state:0,unit:item.unit,id:item.id,boxNo:item.boxNo,item:item.item,qty:item.qty,locationId:item.locationId,value:floor,storDateId:this.storDateId,volume:item.volume,amount:item.amount,remainingQuantity:item.remainingQuantity,remainingVolume:item.remainingVolume,unitVolume:item.unitVolume,unitPrice:item.unitPrice,quantity:item.quantity,checked:false};
                                    if(i === 0){//添加
                                        let storIdItemList={id:item.id,createDate:new Date(item.createDate*1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem:[itemList]};
                                        sotrOnMap.set(i,storIdItemList);
                                    }else{
                                        sotrOnMap.get(0).storOnItem.push(itemList)
                                    }
                                });
                                if(this.addStorOn === true){
                                    this.addStorOnList =[... sotrOnMap.values()];
                                }else {
                                    this.storOnList =[... sotrOnMap.values()];
                                }
                            }
                        });
                    }
                });
            },
            selCutomerCode(){/*查詢客戶編號*/
                return getCustomerCodeList().then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.customerCode =res.data;
                        let sotrOnMap= new Map();
                        this.customerCode.forEach((a,b)=>{
                            this.$set(this.customerCode[b],'value',a.code);//向陣列裡添加value欄位
                            sotrOnMap.set(b,{id:a.id,code:a.code});
                        });
                        let list =[... sotrOnMap.values()];
                        this.list = list.map(item => {
                            return { value: item.id, label: item.code };
                        });
                    }
                });
            },
            submitStorIn(){/*出倉*/
                let addstorOnList =[... this.addStorOnMap.values()];
                if(addstorOnList.length==0){
                    return this.$alert("請選擇出倉記錄", '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                }
                if(this.form.sCode === null || this.form.sCode === "" || this.form.sCode===undefined){
                    return this.$alert("工作單號不能為空", '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                }
                var codeId = this.form.sCode.split(',');
                let code="";
                if(this.rkCont === true){
                    this.codeList.forEach(item =>{
                        if(item.code === codeId[1]){
                            this.addStorOn=true;
                        }
                    });
                }
                if(codeId[1] !== undefined){//確定codeID中是否有值
                    code = codeId[1];
                }else{ code = this.form.sCode; }
                let params={
                    code:code,
                    addStorOn:this.addStorOn,
                    customers:{
                        id:this.form.id,
                        code:this.form.code,
                        name:this.form.name,
                        address:this.form.address,
                        phone:this.form.phone,
                        sales:this.form.sales,
                        createDate:Math.round((new Date(this.form.createDate)).getTime()/1000)
                    }, storOnItemList:addstorOnList
                };
                //console.log("params",params);
                let str = this.isStringNull();
                if(str !== ""){
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                }else{
                    this.$confirm('確定是否出倉? ', '提示', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        insertStorOn(params).then(data =>{
                            let {data:res={}}=data;
                            if(res.errcode === 200){
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.cancelAdd();
                                //this.getStorOnList();
                                this.addStorOnMap=new Map();
                                this.$router.push({
                                    name: '出倉',
                                    params: {str: new Date().getTime()}
                                })
                                this.$store.commit("closeTab", 'addStockout');
                            }else {
                                this.$message.error(res.errmsg);
                            }
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                }
            },
            checkedOne(index, item){
                let list={};
                if(this.addStorOn===false){
                    list = this.storOnList[0].storOnItem[index];
                }else{
                    list = this.addStorOnList[0].storOnItem[index];
                }
                let storOn = {storInItemId:list.id,state:1,unit:list.unit,id:list.id,boxNo:list.boxNo,item:list.item,qty:list.qty,locationId:list.locationId,value:list.value,storDateId:list.storDateId,volume:list.volume,amount:list.amount,remainingQuantity:list.remainingQuantity,remainingVolume:list.remainingVolume,unitVolume:list.unitVolume,unitPrice:list.unitPrice,quantity:list.quantity,checked:false};
                if(!this.addStorOnMap.has(list.id)){
                    if(this.addStorOnList.length !== 0){
                        this.addStorOnList[0].storOnItem[index].state =1;
                    }
                    this.addStorOnMap.set(list.id,storOn)
                }else{
                    this.addStorOnList[0].storOnItem[index].state =0;
                    this.addStorOnMap.delete(list.id)
                }
            },
            // changeOne(val, row, index) {
            //     row.state = 1
            //     row.quantity = row.remainingQuantity
            //     let list = {}
            //     if(this.addStorOn===false){
            //         list = this.storOnList[0].storOnItem[index];
            //     }else{
            //         list = this.addStorOnList[0].storOnItem[index];
            //     }
            //     let storOn = {storInItemId:list.id,state:1,unit:list.unit,id:list.id,boxNo:list.boxNo,item:list.item,qty:list.qty,locationId:list.locationId,value:list.value,storDateId:list.storDateId,volume:list.volume,amount:list.amount,remainingQuantity:list.remainingQuantity,remainingVolume:list.remainingVolume,unitVolume:list.unitVolume,unitPrice:list.unitPrice,quantity:list.quantity,checked:true};
            //     if(val){
            //         row.remark = '出整' + list.unit + '，共' + this.dialogForm.quantity +'件' 
            //         if(!this.addStorOnMap.has(list.id)){
            //             if(this.addStorOnList.length !== 0){
            //                 this.addStorOnList[0].storOnItem[index].state = 1;
            //             }
            //             this.addStorOnMap.set(list.id,storOn)
            //         }else{
            //             this.addStorOnList[0].storOnItem[index].state =1;
            //         }
            //     }else{
            //         if(this.addStorOnMap.has(list.id)){
            //             if(this.addStorOnList.length !== 0){
            //                 this.addStorOnList[0].storOnItem[index].state = 0;
            //             }
            //             row.state = 0
            //             row.remark = ''
            //             this.addStorOnMap.delete(list.id)
            //         }
            //     }
            //     this.$forceUpdate()
            // },
            handleStor(index) {
                this.curIndex = index
                if(this.addStorOn===false){
                    this.dialogForm = this.storOnList[0].storOnItem[index]
                }else{
                    this.dialogForm = this.addStorOnList[0].storOnItem[index]
                }
                if(!this.dialogForm.checked) {
                    this.dialogForm.quantity = 1
                    this.dialogForm.volume = null
                    this.dialogForm.amount = 0
                }
                console.log(this.dialogForm)
                this.dialogVisible = true
            },
            handleItem() {
                const id = this.dialogForm.id
                const unit = this.dialogForm.unitVolume == '1' ? '箱' : this.dialogForm.unitVolume == '2'?'cu.ft':this.dialogForm.unitVolume == '3'?'m³':''
                if(this.dialogForm.state==1 || this.dialogForm.state==4) {
                    this.dialogForm.checked = true
                    if(this.dialogForm.quantity == this.dialogForm.remainingQuantity) this.dialogForm.state=1
                    if(this.dialogForm.state==1){
                        this.dialogForm.quantity = this.dialogForm.remainingQuantity
                        this.dialogForm.remark = `出整${this.dialogForm.unit}，共${this.dialogForm.quantity}件${this.dialogForm.volume?'，體積'+this.dialogForm.volume+unit:''}`
                    }
                    if(this.dialogForm.state==4){
                        this.dialogForm.remark = `出部分，${this.dialogForm.quantity}件${this.dialogForm.volume?'，體積'+this.dialogForm.volume+unit:''}`
                    }
                    if(!this.addStorOnMap.has(id)){
                        if(this.addStorOnList.length !== 0){
                            this.addStorOnList[0].storOnItem[this.curIndex].state = this.dialogForm.state;
                        }
                        this.addStorOnMap.set(id,this.dialogForm)
                    }else{
                        this.addStorOnMap.set(id,this.dialogForm)
                    }
                }else{
                    this.dialogForm.state = 0
                    this.dialogForm.remark = ''
                    this.dialogForm.checked = false
                    if(this.addStorOnMap.has(id)){
                        if(this.addStorOnList.length !== 0){
                            this.addStorOnList[0].storOnItem[this.curIndex].state = 0;
                        }
                        this.addStorOnMap.delete(id)
                    }
                }
                this.dialogVisible = false
            },
            nullList(){/*清空*/
                this.storOnList=[];
                this.storDateId=0;
                this.isNullOptions();
                this.form ={
                    id:null, code:null, name:null, phone:null, address:null, sales:null, createDate:null
                };
                this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            },
            isStringNull(){/*檢查是否為空*/
                let str="";
                if(this.form.sCode === null || this.form.sCode === "" || this.form.sCode===undefined){
                    return "出庫單不能為空"
                }if(this.form.code === null || this.form.code === ""){
                    return "客戶編號不能為空"
                }if(this.form.name === null || this.form.name === ""){
                    return"姓名不能為空"
                }if(this.form.phone === null || this.form.phone === ""){
                    return"電話不能為空"
                }if(this.form.address === null || this.form.address === ""){
                    return"位址不能為空"
                }if(this.form.sales === null || this.form.sales === ""){
                    return"銷售員不能為空"
                }if(this.form.createDate === null || this.form.createDate === ""){
                    return "時間不能為空"
                }
                return str;
            },
            test(){
                this.show=true;
                this.add = false;
            },
            getInCodeList(){/*查詢入庫單號*/
                getStorInCodeList().then(data =>{/*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                    let {data:res={}}=data;
                    //console.log("11",res);
                    if(res.errcode===200){
                        this.codeInList = res.data;
                        let sotrOnMap= new Map();
                        this.codeInList.forEach((a,b)=>{
                            this.$set(this.codeInList[b],'value',a.code);//向陣列裡添加value欄位
                            sotrOnMap.set(b,{id:a.id,code:a.code});
                        });
                        let list =[... sotrOnMap.values()];
                        this.codeInList = list.map(item => {
                            return { value: item.id+","+item.code, label: item.code };
                        });
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            isNullOptions(){
                this.options=[];
            },
        },
        activated(){
            getStaffAllList().then(data=>{
                let {data:res={}}=data;
                this.custSalesList=res.data;
            });
            /*進入載入*/
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
            this.selCutomerCode();
            this.storInAdd();
        },
        computed:{
            canAdd(){
                return this.$store.getters.hasPermission("ADD_STOR_ON");
            },
            canEdit(){
                return this.$store.getters.hasPermission("EDIT_STOR_ON");
            },
        },
        watch:{
            '$route':'test'
        }
    }
</script>
<style >
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
    .xinz button:hover{background:#4B78FF;color:#fff;}
    .el-form-item {
        margin-bottom: 5px;
    }
    .stateShow{
        background-color:#d3d3d3;
    }
</style>




// WEBPACK FOOTER //
// src/views/AddStockOut.vue